/** Formatadores fiscais — mesmos do backend, para o que a UI calcula localmente. */

const MOEDA = new Intl.NumberFormat("pt-BR", {
  style: "currency",
  currency: "BRL",
  maximumFractionDigits: 2,
});

export const brl = (valor: number) => MOEDA.format(Number.isFinite(valor) ? valor : 0);

export const pct = (valor: number) => `${(valor * 100).toFixed(2).replace(".", ",")}%`;

/** 0.07 → "7"; 0.1038 → "10,38" — usado na matriz origem × destino. */
export const pctCurto = (valor: number) => {
  const n = valor * 100;
  return n % 1 === 0 ? String(n) : n.toFixed(2).replace(".", ",");
};

export const dataBR = (iso: string | null | undefined) => {
  if (!iso) return "—";
  const d = new Date(iso);
  return Number.isNaN(d.getTime()) ? iso : d.toLocaleDateString("pt-BR");
};

export const numero = (texto: string) => Number(texto.replace(",", ".")) || 0;
